<template>
  <div class="app-wrapper">
    <div class="app__step">
      <ul :class="'app__step-'+stepApp">
        <li :class="[stepApp == 1 ? 'active' : '', stepApp > 1 ? 'checked' : '']"><b>1</b><span>Эмоциональные состояния</span></li>
        <li :class="[stepApp == 2 ? 'active' : '', stepApp > 2 ? 'checked' : '']"><b>2</b><span>Физический дискомфорт</span></li>
        <li :class="[stepApp == 3 ? 'active' : '', stepApp > 3 ? 'checked' : '']"><b>3</b><span>Заболевания</span></li>
        <li :class="[stepApp == 4 ? 'active' : '', stepApp > 4 ? 'checked' : '']"><b>4</b><span>Особенности питания</span></li>
      </ul>
    </div>
    <div class="steps_view">
      <div v-if="stepApp == 0" class="step_view step_view__0">
        <div class="step_view__inner">
          <div class="text_wrapper">
            <p><b>Для определения наличия возможного дефицита магния в организме предлагаем ответить на 4 блока вопросов.</b></p>
            <img src="@/assets/images/step_1_mobile.png" />
          </div>
          <div class="button" @click="stepApp = 1"><span>Начать</span></div>
        </div>
      </div>
      <div v-if="stepApp == 1" class="step_view step_view__1">
        <div class="step_view__inner step_view__inner__1">
          <div class="text_wrapper">
            <p><b>Отметьте характерные для себя эмоциональные состояния</b></p>
          </div>
          <img src="@/assets/images/step_2_desk.png" style='height: 205px' />
          <div class="step_view__inputs">
            <ul>
              <li v-for="(checked, index) in checkeds[0]" :key="index"><label><input v-model="checked.checked" type="checkbox" /><i :class="checked.checked ? 'active' : '' "></i>{{checked.name}}</label></li>
            </ul>
          </div>
          <div class="buttons">
            <div class="button" @click="stepApp = 2"><span>Далее</span></div>
          </div>
        </div>
      </div>
      <div v-if="stepApp == 2" class="step_view step_view__2">
        <div class="step_view__inner step_view__inner__2">
          <div class="text_wrapper">
            <p><b>Отметьте характерные для себя состояния, связанные с физическим дискомфортом</b></p>
          </div>
          <img src="@/assets/images/step_3_desk.png" style='height: 205px' />
          <div class="step_view__inputs">
            <ul>
              <li v-for="(checked, index) in checkeds[1]" :key="index"><label><input v-model="checked.checked" type="checkbox" /><i :class="checked.checked ? 'active' : '' "></i>{{checked.name}}</label></li>
            </ul>
          </div>
          <div class="buttons">
            <div class="button" @click="stepApp = 3"><span>Далее</span></div>
            <div class="button button__white" @click="--stepApp"><span>Назад</span></div>
          </div>
        </div>
      </div>
      <div v-if="stepApp == 3" class="step_view step_view__3">
        <div class="step_view__inner step_view__inner__3">
          <div class="text_wrapper">
            <p><b>Отметьте имеющиеся у вас заболевания</b></p>
          </div>
          <img src="@/assets/images/step_4_desk.png" style='height: 144px' />
          <div class="step_view__inputs">
            <ul>
              <li v-for="(checked, index) in checkeds[2]" :key="index"><label><input v-model="checked.checked" type="checkbox" /><i :class="checked.checked ? 'active' : '' "></i>{{checked.name}}</label></li>
            </ul>
          </div>
          <div class="buttons">
            <div class="button" @click="stepApp = 4"><span>Далее</span></div>
            <div class="button button__white" @click="--stepApp"><span>Назад</span></div>
          </div>
        </div>
      </div>
      <div v-if="stepApp == 4" class="step_view step_view__4">
        <div class="step_view__inner step_view__inner__4">
          <div class="text_wrapper">
            <p><b>Отметьте свойственные вам особенности питания</b></p>
          </div>
          <img src="@/assets/images/step_5_desk.png" style='height: 175px' />
          <div class="step_view__inputs">
            <ul>
              <li v-for="(checked, index) in checkeds[3]" :key="index"><label><input v-model="checked.checked" type="checkbox" /><i :class="checked.checked ? 'active' : '' "></i>{{checked.name}}</label></li>
            </ul>
          </div>
          <div class="buttons">
            <div class="button" @click="resultApp"><span>Узнать свой статус</span></div>
            <div class="button button__white" @click="--stepApp"><span>Назад</span></div>
          </div>
        </div>
      </div>
      <div v-if="stepApp == 5" class="step_view step_view__5">
        <div :class="'step_view__inner step_view__inner__5_'+result">
          <div v-if="result == 0" class="text_wrapper">
            <p><b>Похоже, у вас дефицит магния. Это может быть серьезно!</b></p>
            <p>Постарайтесь больше отдыхать, питайтесь сбалансированно, а восполнить дефицит магния могут помочь лекарства, содержащие магний*.</p>
            <p class="small">* Перед применением проконсультируйтесь со специалистом.</p>
          </div>
          <div v-if="result == 1" class="text_wrapper">
            <p><b>Поздравляем!<br> Похоже, с уровнем магния в вашем организме все хорошо!</b></p>
            <p>Если вам кажется, что у кого-то дела обстоят не так блестяще – отправьте им этот тест!</p>
          </div>
          <img v-if="result == 0"  src="@/assets/images/result_height_mobile.png" style='height: 130px' />
          <img v-if="result == 1"  src="@/assets/images/result_low_mobile.png" style='height: 114px' />
          <div class="buttons">
            <div class="button" @click="back"><span>Пройти заново</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import AppFooter from './AppFooter.vue'
export default {
  name: 'AppMain',
  components: {
  },
  data() {
    return {
      stepApp: 0,
      result: 0,
      balls: 0,
      checkeds: [
        [
          {
            name: 'Чрезмерное эмоциональное напряжение',
            checked: false,
            ball: 2
          },
          {
            name: 'Раздражительность или повышенная возбудимость',
            checked: false,
            ball: 2
          },
          {
            name: 'Бессонница',
            checked: false,
            ball: 1
          },
          {
            name: 'Хроническая депрессия без видимой причины',
            checked: false,
            ball: 2
          },
          {
            name: 'Потеря концентрации внимания',
            checked: false,
            ball: 1
          },
          {
            name: 'Чувство беспречинного беспокойства',
            checked: false,
            ball: 2
          },
          {
            name: 'Значительное снижение сексуальной и жизненной активности',
            checked: false,
            ball: 2
          }
        ],
        [
          {
            name: 'Судороги',
            checked: false,
            ball: 2
          },
          {
            name: 'Мелкие, едва заметные подергивания мышц вокруг глаз, мышц лица или других мышц тела',
            checked: false,
            ball: 1
          },
          {
            name: 'Спазм мышц рук и ног',
            checked: false,
            ball: 2
          },
          {
            name: '«Ком в горле» или чувство удушья из-за спазмов пищевода',
            checked: false,
            ball: 2
          },
          {
            name: 'Мышечная слабость',
            checked: false,
            ball: 2
          },
          {
            name: 'Постоянное чувство покалывания в теле',
            checked: false,
            ball: 2
          },
          {
            name: 'Хроническая усталость',
            checked: false,
            ball: 1
          },
          {
            name: 'Частые диареи или запоры',
            checked: false,
            ball: 2
          }
        ],
        [
          {
            name: 'Хроническая болезнь почек',
            checked: false,
            ball: 2
          },
          {
            name: 'Пролапс митрального клапана',
            checked: false,
            ball: 4
          }
        ],
        [
          {
            name: 'Диета с низким содержанием зелени, овощей, семян и свежих фруктов',
            checked: false,
            ball: 1
          },
          {
            name: 'Высокая потребность в углеводах и/или шоколаде',
            checked: false,
            ball: 2
          },
          {
            name: 'Употребление более 7 порций алкоголя в течение недели ',
            checked: false,
            ball: 1
          },
          {
            name: 'Регулярное употребление препаратов кальция без магния',
            checked: false,
            ball: 3
          },
          {
            name: 'Частый прием антибиотиков, стероидов, пероральных контрацептивов, индометацина, цисплатина, амфотерицина В, холестирамина, синтетических эстрогенов',
            checked: false,
            ball: 1
          },
          {
            name: 'Прием мочегонных препаратов',
            checked: false,
            ball: 1
          }
        ]
      ]
    }
  },
  methods: {
    back () {
      this.stepApp = 0;
      this.balls = 0;
      this.checkeds.map((item) => {
        for(let i=0;i<item.length;i++) {
          if(item[i].checked) {
            item[i].checked = false
          }
        }
      })
    },
    resultApp () {
      this.checkeds.map((item) => {
        for(let i=0;i<item.length;i++) {
          if(item[i].checked) {
            this.balls += item[i].ball
          }
        }
      })
      if(this.balls < 9) {
        this.result = 1
      } else {
        this.result = 0
      }
      this.stepApp++
    }
  }
}
</script>

<style lang="scss">
$maxWidth: 768px;

#app {
  .app-wrapper {
    max-width: 1220px;
    margin: 0px auto 0px;
    .app__step {
      max-width: 508px + 32px;
      margin: 0px auto 0px;
      padding: 0px 16px 60px;
      @media (max-width: $maxWidth) {
        padding-bottom: 0px + 12px;
      }
      ul {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 2px;
        background: #B2B2B2;
        margin: 28px 0px;
        position: relative;
        @media (max-width: $maxWidth) {
          &:before {
            content: '';
            position: absolute;
            left: 0px;
            top: 0px;
            bottom: 0px;
            background-color: #0158BB;
          }
          &.app__step {
            &-1 {
              &:before {
                width: 0%;
              }
            }
            &-2 {
              &:before {
                width: calc(100% / 3);
              }
            }
            &-3 {
              &:before {
                width: calc(100% / 3 * 2);
              }
            }
            &-4 {
              &:before {
                width: 100%;
              }
            }
          }
        }
        li {
          width: 28px;
          height: 28px;
          background: #BDBDBD;
          border-radius: 50%;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          b {
            font-size: 18px;
            line-height: 24px;
            color: #FFFFFF;
          }
          span {
            position: absolute;
            top: 100%;
            text-align: center;
            font-weight: 400;
            font-size: 13px;
            line-height: 16px;
            left: 50%;
            transform: translateX(-50%);
            padding-top: 8px;
            @media (max-width: $maxWidth) {
              display: none;
            }
          }
          &.active {
            background: #0158BB;
          }
          &.checked {
            @media (max-width: $maxWidth) {
              background: #F0F0F5;
              border: 2px solid #0158BB;
              &:before {
                content: '';
                background-image: url('@/assets/images/checked.svg');
                width: 17px;
                height: 13px;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
              }
              b {
                display: none;
              }
            }
          }
        }
      }
    }
    .steps_view {
      .step_view {
        padding: 52px;
        &__inputs {
          ul {
            columns: auto 2;
            @media (max-width: $maxWidth) {
              columns: auto 1;
            }
            li {
              padding: 12px 0;
              label {
                display: flex;
                cursor: pointer;
                font-weight: 300;
                font-size: 18px;
                line-height: 24px;
                color: #000000;
                input {
                  display: none;
                }
                i {
                  border: 2px solid #000000;
                  width: 18px;
                  height: 18px;
                  margin-right: 8px;
                  margin-top: 3px;
                  flex: 0 0 auto;
                  &.active {
                    &:before {
                      content: '';
                      width: 8px;
                      height: 8px;
                      background-color: #000;
                      display: block;
                      border: 3px solid #F0F0F5;
                      box-sizing: content-box;
                    }
                  }
                }
              }
            }
          }
        }
        &__0 {
          background-color: #F0F0F5;
          @media (max-width: $maxWidth) {
            background-color: transparent;
            padding: 0px;
          }
          .step_view__inner {
            padding-right: 50%;
            background-image: url('@/assets/images/step_1_desk.png');
            background-repeat: no-repeat;
            background-size: 100% auto;
            background-position: 0% bottom;
            height: 352px;
            @media (max-width: $maxWidth) {
              height: auto;
              background-image: none;
              padding-right: 0%;
              > div.text_wrapper {
                background-color: #F0F0F5;
                padding: 28px 16px;
              }
            }
          }
          p {
            margin: 0px 0px 40px;
            font-size: 20px;
            line-height: 28px;
            color: #000000;
            @media (max-width: $maxWidth) {
              font-weight: 400;
              font-size: 16px;
              line-height: 20px;
              margin-bottom: 20px;
            }
            b {

            }
          }
          img {
            display: none;
            @media (max-width: $maxWidth) {
              display: block;
              margin: 0px auto 0px;
            }
          }
          .button {
            width: 100%;
            max-width: 360px;
            cursor: pointer;
            display: block;
            @media (max-width: $maxWidth) {
              margin: 32px auto 0px; 
            }
          }
        }
        &__1, &__2, &__3, &__4, &__5 {
          background-color: #F0F0F5;
          .step_view__inner {
            padding-right: 28%;
            background-repeat: no-repeat;
            background-position: right center;       
            &__1 {
              background-image: url('@/assets/images/step_2_desk.png');
              background-size: 25% auto;
              min-height: 306px;
            }
            &__2 {
              background-image: url('@/assets/images/step_3_desk.png');
              background-size: 22% auto;
              min-height: 362px;
            }
            &__3 {
              background-image: url('@/assets/images/step_4_desk.png');
              background-size: 22% auto;
              min-height: 195px;
              .step_view__inputs {
                ul {
                  columns: auto 1;
                }
              }
            }
            &__4 {
              background-image: url('@/assets/images/step_5_desk.png');
              background-size: 22% auto;
              min-height: 362px;
            }
            &__5_0 {
              background-image: url('@/assets/images/result_height_desk.png');
              background-size: 40% auto;
              min-height: 230px;
              padding-right: 45%;
            }
            &__5_1 {
              background-image: url('@/assets/images/result_low_desk.png');
              background-size: 40% auto;
              min-height: 230px;
              padding-right: 45%;
            }
            @media (max-width: $maxWidth) {
              min-height: none;
              background-image: none;
              padding-right: 0%;
            }
          }
          @media (max-width: $maxWidth) {
            padding: 28px 16px;
          }
          p {
            margin: 0px 0px 30px;
            font-size: 20px;
            line-height: 28px;
            color: #000000;
            &.small {
              font-weight: 400;
              font-size: 13px;
              line-height: 16px;
              color: #707075;
            }
            @media (max-width: $maxWidth) {
              font-weight: 400;
              font-size: 16px;
              line-height: 20px;
              margin-bottom: 20px;
            }
            b {

            }
          }
          img {
            display: none;
            @media (max-width: $maxWidth) {
              display: block;
              margin: 30px auto 20px;
            }
          }
          .buttons {
            margin: 32px 0px 0; 
            @media (max-width: $maxWidth) {
              display: block;
              margin: 20px 0px 0; 
            }
            .button {
              max-width: 360px;
              width: 100%;
              cursor: pointer;
              display: block;
              &__white {
                background-color: #fff;
                color: #000;
                margin-left: 24px;
              }
              @media (max-width: $maxWidth) {
                margin: 12px auto 0px; 
                max-width: none;
              }
            }
          }
        }
      }
    }
  }
}
</style>
